const Services = () => {
    return (
        <section className='page-section bg-light' id='servizi'>
            <div className='container' data-aos='fade-up'>
                <div className='text-center'>
                    <h2 className='section-heading text-uppercase'>Servizi</h2>
                    <h3 className='section-subheading text-muted'>Offriamo una vasta gamma di servizi per i nostri clienti</h3>
                </div>
                <div className='row text-center'>
                    <div className='col-md-4'>
                        <span className='fa-stack fa-4x'>
                            <i className='fas fa-circle fa-stack-2x text-primary'></i>
                            <i className='fas fa-truck-moving fa-stack-1x fa-inverse'></i>
                        </span>
                        <h4 className='my-3'>Trasporti</h4>
                        <p className='text-muted'>
                            Con un’esperienza pluriventennale nel settore effettuiamo trasporti di ogni tipo, dai macchinari al materiale da
                            cantiere, proponendo automezzi di portata variabile, a seconda del peso e delle dimensioni dell’oggetto
                            trasportato.
                        </p>
                    </div>
                    <div className='col-md-4'>
                        <span className='fa-stack fa-4x'>
                            <i className='fas fa-circle fa-stack-2x text-primary'></i>
                            <i className='far fa-handshake fa-stack-1x fa-inverse'></i>
                        </span>
                        <h4 className='my-3'>Noleggio</h4>
                        <p className='text-muted'>
                            Siamo in grado di offrirVi macchine industriali con una vasta gamma di altezze e portate.
                            <br />
                            Ciò al fine di proporre sempre il mezzo più idoneo alle esigenze del cliente, con la consulenza di tecnici
                            altamente formati.
                        </p>
                    </div>
                    <div className='col-md-4'>
                        <span className='fa-stack fa-4x'>
                            <i className='fas fa-circle fa-stack-2x text-primary'></i>
                            <i className='fas fa-user-check fa-stack-1x fa-inverse'></i>
                        </span>
                        <h4 className='my-3'>Assistenza Tecnica</h4>
                        <p className='text-muted'>
                            Il team di consulenti qualificati permette una gestione ottimale del servizio, dalla fase iniziale relativa alla
                            scelta del macchinario da utilizzare al completamento del lavoro, con valutazioni anche in corso d’opera per
                            soddisfare le diverse esigenze del cliente.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default Services;
